import { CommonRules } from "./common";
import { TspRules } from "./tsp";

export { CommonRules };

export const ClientRules = {
  tsp: TspRules
};
